module.exports = __webpack_public_path__ + "img/salon-2015.00272085.jpg";